import { useEffect } from "react";
import { useBlocker } from "react-router-dom";
import ConfirmDialog from "./confirmDialog";

const UnsavedChangesDialog = ({
    shouldBlockNavigation = false,
    title = "Cambios sin guardar",
    text = "Si sigue perdera los cambios del formulario actual",
}) => {
    const blocker = useBlocker(({ nextLocation }) => {
        if (!shouldBlockNavigation) {
            return false;
        }

        return !nextLocation?.state?.skipUnsavedGuard;
    });

    useEffect(() => {
        if (blocker.state === "blocked" && !shouldBlockNavigation) {
            blocker.reset();
        }
    }, [blocker, shouldBlockNavigation]);

    const handleClose = () => {
        blocker.reset();
    };

    const handleConfirm = () => {
        blocker.proceed();
    };

    return (
        <ConfirmDialog
            open={blocker.state === "blocked"}
            handleClose={handleClose}
            handleConfirm={handleConfirm}
            title={title}
            text={text}
        />
    );
};

export default UnsavedChangesDialog;